/**
 * Tagged template function for HTML strings.
 * Enables syntax highlighting and Prettier formatting for HTML in template literals.
 *
 * @param strings - Template string array
 * @param values - Interpolated values
 * @returns Concatenated HTML string
 */
export const html = (
  strings: TemplateStringsArray,
  ...values: any[]
): string => {
  return strings.reduce((result, string, i) => {
    return result + string + (values[i] || "");
  }, "");
};

/**
 * Tagged template function for XML strings.
 * Enables syntax highlighting and Prettier formatting for XML in template literals.
 *
 * @param strings - Template string array
 * @param values - Interpolated values
 * @returns Concatenated XML string
 */
export const xml = (
  strings: TemplateStringsArray,
  ...values: any[]
): string => {
  return strings.reduce((result, string, i) => {
    return result + string + (values[i] || "");
  }, "");
};

/**
 * Tagged template function for CSS strings.
 * Enables syntax highlighting and Prettier formatting for CSS in template literals.
 *
 * @param strings - Template string array
 * @param values - Interpolated values
 * @returns Concatenated CSS string
 */
export const css = (
  strings: TemplateStringsArray,
  ...values: any[]
): string => {
  return strings.reduce((result, string, i) => {
    return result + string + (values[i] || "");
  }, "");
};
